export default __webpack_public_path__ + "static/media/property_768.3d89ca0e.png";